import dayjs from 'dayjs';

export function isLastOccurrenceOfWeekday(date: Date) {
  const inputDate = dayjs(date);

  const lastDayOfMonth = inputDate.endOf('month'); // Get the last day of the month

  // Check if the next occurrence of this weekday is in the next month
  const nextWeekday = inputDate.add(7, 'day');

  return nextWeekday.isAfter(lastDayOfMonth);
}
